import PermissionGateComponent from "@/components/PermissionGateComponent/PermissionGateComponent.vue";
import type { PermissionResult } from "@territoriesai/types/lib/helpers/permission.helper.mjs";
import { ref, useTemplateRef, watchEffect } from "vue";

export const usePermissionGate = (refName: string) => {
  const permissionResult = ref<PermissionResult | null>(null);
  const permissionGate =
    useTemplateRef<typeof PermissionGateComponent>(refName);
  watchEffect(() => {
    permissionResult.value = permissionGate.value?.result ?? null;
  });

  return {
    permissionGate,
    permissionResult
  };
};
